import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiError, DetailView } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';
import Competences from '../components/Competences';
import Details from '../components/Details';
import { AuditorRegistrationDetail } from '../types';
import { getAuditorRegistrationById } from '../api/getAuditorRegistrationById';

const DetailPage = () => {
  const { id } = useParams<{ id: string }>() as { id: string };

  const { t } = useTranslation();
  const navigate = useNavigate();

  const auditorRegistrationQuery = useQuery<AuditorRegistrationDetail, ApiError>(
    ['auditor-registrations-id', id],
    () => getAuditorRegistrationById(id),
    { refetchOnWindowFocus: false }
  );

  if (auditorRegistrationQuery.isLoading) {
    return (
      <Box>
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={100} />
        </Box>
      </Box>
    );
  }

  if (auditorRegistrationQuery.isError) {
    return <p>{auditorRegistrationQuery.error.message}</p>;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <DetailView
        title={<DetailView.Title>{auditorRegistrationQuery.data.note || 'N/A'}</DetailView.Title>}
        onGoBack={() => navigate('/valid-registrations')}
        tabs={[
          { id: 'details', title: t('Details', { defaultValue: 'Details' }) },
          { id: 'competences', title: t('Competences', { defaultValue: 'Competences' }) },
        ]}
        defaultTab="details"
        childrenSx={{ padding: '2rem' }}
      >
        {({ TabContent }) => (
          <>
            <TabContent tab="details">
              <Details auditorRegistrationDetail={auditorRegistrationQuery.data} />
            </TabContent>
            <TabContent tab="competences">
              <Competences auditorRegistrationDetail={auditorRegistrationQuery.data} />
            </TabContent>
          </>
        )}
      </DetailView>
    </Box>
  );
};

export default DetailPage;
